import { RichText } from 'app/components'
import { RichTextBlock } from './rich-text.block'

export const RichTextComponent = (block: RichTextBlock) => {
  return (
    <RichText
      content={block.richText}
      expandable={block.expandable}
      textProps={{
        textAlign: block.alignment,
      }}
    />
  )
}
